import React from 'react';
import LegalDocumentPage from './LegalDocumentPage';
import { LegalDocumentEnum } from '../../interfaces/LegalDocument';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <LegalDocumentPage
      documentType={LegalDocumentEnum.PRIVACY_POLICY}
      title="Privacy Policy"
      translationKey="FLEET_PRIVACY_POLICY"
    />
  );
};

export default PrivacyPolicyPage;
